/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const initiativeSummarySchema = z.object({
  itemId: z.int(),
  name: z.string(),
});
